import * as toast from './toast';
const FIREBASE_ERROR = new Map([
  ['auth/user-not-found', 'Incorrect email address or password '],
  ['auth/wrong-password', 'Incorrect password'],
  ['auth/wrong-old-password', 'Incorrect old password'],
  ['auth/network-request-failed', 'Please check your internet connection.'],
  ['auth/user-not-found', "User Doesn't Exist"] /* eslint-disable-line */,
  ['auth/not-admin', `User isn't an admin`],
  ['auth/uid-already-exists', 'User already exist'],
  ['permission-denied', `Unauthorized`],
]);

const CUSTOM_ERROR = new Map([['auth/user-suspended', 'User is suspended']]);

const ERRORS = new Map([...FIREBASE_ERROR, ...CUSTOM_ERROR]);

const GENERIC_ERROR = 'Oops! Something went wrong';

const getErrorMessage = errorCode => {
  const errorMessage = ERRORS.get(errorCode);
  if (typeof errorMessage === 'undefined') {
    return GENERIC_ERROR;
  }
  return errorMessage;
};

/**
 * Generic error handler to handle firebase error.
 * @param {object} firebase error object
 */
export function handleError(event) {
  toast.error({
    title: 'Error',
    message: getErrorMessage(event.code),
  });
}
